import { render, staticRenderFns } from "./sanctioList.vue?vue&type=template&id=4d970804&scoped=true"
import script from "./sanctioList.vue?vue&type=script&lang=js"
export * from "./sanctioList.vue?vue&type=script&lang=js"
import style0 from "./sanctioList.vue?vue&type=style&index=0&id=4d970804&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d970804",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d970804')) {
      api.createRecord('4d970804', component.options)
    } else {
      api.reload('4d970804', component.options)
    }
    module.hot.accept("./sanctioList.vue?vue&type=template&id=4d970804&scoped=true", function () {
      api.rerender('4d970804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/creditList/exposal/sanctio/sanctioList.vue"
export default component.exports